import { AclAction, CompanyRoleEnum } from 'shared/domains/apollo/generated/types';
import useAccount from 'shared/domains/users/hooks/useAccount';
export function useACLCan(params) {
    const { userAcls, teamAcls } = params;
    const account = useAccount();
    const can = (action) => (userId = account.data.userId) => {
        if (userId === account.data.userId && account.data.role === 'owner') {
            if (action === AclAction.Traverse) {
                return false;
            }
            return true;
        }
        const hasUserAccess = userAcls === null || userAcls === void 0 ? void 0 : userAcls.some((access) => access.userId === userId && access.actions.includes(action));
        const hasTeamAccess = teamAcls === null || teamAcls === void 0 ? void 0 : teamAcls.some((access) => {
            var _a, _b;
            const userIsTeamMember = Boolean((_b = (_a = access.team) === null || _a === void 0 ? void 0 : _a.members) === null || _b === void 0 ? void 0 : _b.some((member) => member.userId === userId));
            return userIsTeamMember && access.actions.includes(action);
        });
        // Because of legacy reasons, lets assume all data can be undefined.
        const hasAccessTroughProject = teamAcls === null || teamAcls === void 0 ? void 0 : teamAcls.some((access) => {
            var _a, _b, _c;
            const isProjectTeam = (_a = access.team) === null || _a === void 0 ? void 0 : _a.isProjectTeam;
            const hasAction = access.actions.includes(action);
            const userIsTeamMember = Boolean((_c = (_b = access.team) === null || _b === void 0 ? void 0 : _b.members) === null || _c === void 0 ? void 0 : _c.some((member) => member.userId === userId));
            return isProjectTeam && hasAction && userIsTeamMember;
        });
        return Boolean(hasUserAccess || hasTeamAccess || hasAccessTroughProject);
    };
    const getAccessLevel = (userId, role) => {
        if (role === 'owner') {
            return 'full';
        }
        if (can(AclAction.Write)(userId)) {
            return 'full';
        }
        if (can(AclAction.Read)(userId)) {
            return 'read';
        }
        if (can(AclAction.Traverse)(userId)) {
            return 'traverse';
        }
        return 'none';
    };
    return {
        canTraverse: can(AclAction.Traverse),
        canRead: can(AclAction.Read),
        canWrite: can(AclAction.Write),
        canDelete: can(AclAction.Delete),
        accessLevel: getAccessLevel(account.data.userId || '', account.data.role || CompanyRoleEnum.Member),
        getAccessLevel,
    };
}
